var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sale-title flex justify-between"
  }, [_vm._t("title"), _c("div", {
    staticClass: "sale-time"
  }, [_vm._l(_vm.timeOption, function (item) {
    return _c("span", {
      key: item.key,
      staticClass: "time-item pointer",
      class: {
        activeTime: _vm.currentType === item.key
      },
      on: {
        click: function ($event) {
          return _vm.changeType(item.key);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.label)) + " ")]);
  }), _vm.currentType === "range" ? _c("a-range-picker", {
    staticStyle: {
      width: "250px",
      "margin-left": "10px"
    },
    attrs: {
      placeholder: [_vm.$t("开始日期"), _vm.$t("结束日期")]
    },
    on: {
      change: _vm.changeTime
    }
  }, [_c("a-icon", {
    attrs: {
      slot: "suffixIcon",
      type: "smile"
    },
    slot: "suffixIcon"
  })], 1) : _vm._e()], 2)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };